import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pre-incident',
  templateUrl: './pre-incident.component.html',
  styleUrls: ['./pre-incident.component.scss']
})
export class PreIncidentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
